export const IS_SEARCH_BUTTON_CLICKED = " IS_SEARCH_BUTTON_CLICKED";
export const GETSEARCHDATA_SUCCESS = " GETSEARCHDATA_SUCCESS";
export const IS_FETCHING_SEARCH_RESULTS = " IS_FETCHING_SEARCH_RESULTS";
export const ERROR_SEARCHING_RESULTS = " ERROR_SEARCHING_RESULTS";
